// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2uYZn","content":"LayoutSettings_content__3itkj"};